/* import __COLOCATED_TEMPLATE__ from './application-parameters.hbs'; */
import Component from '@glimmer/component';
import { service } from '@ember/service';
import { action } from '@ember/object';
import Constants from '../../utils/constants';
import Utils from '../../utils/utils';

import CurrentSourceApplicationParameters from '../current-source-dac/application-parameters';
import CurrentSourceSinkApplicationParameters from '../current-source-sink-dac/application-parameters';
import FastPrecisionApplicationParameters from '../fast-precision-dac/application-parameters';
import MultiplyingApplicationParameters from '../multiplying-dac/application-parameters';
import VoltageOutputApplicationParameters from '../voltage-output-dac/application-parameters';

const APP_PARM_CLASSES = {
  'current-source-dac': CurrentSourceApplicationParameters,
  'current-source-sink-dac': CurrentSourceSinkApplicationParameters,
  'fast-precision-dac': FastPrecisionApplicationParameters,
  'multiplying-dac': MultiplyingApplicationParameters,
  'voltage-output-dac': VoltageOutputApplicationParameters,
};

export default class ApplicationParameters extends Component {
  @service intl;
  @service tabService;

  get parametersClass() {
    return APP_PARM_CLASSES[this.args.model.signalChainHandler.dac.type.name];
  }

  get dacResolutionMessage() {
    const resInBits = this.args.model.signalChainHandler.dac.resolutionInBits;
    return Utils.isNumeric(resInBits) ? this.intl.t('messages.resolution_in_bits', { res: resInBits }) : '';
  }

  get selectPartTooltip() {
    return this.intl.t('labels.select_type', {
      article: this.intl.t(`labels.articles.${this.args.model.signalChainHandler.dac.type.article}`),
      type: this.intl.t(`labels.parts.${this.args.model.signalChainHandler.dac.type.appName}`),
    });
  }

  get dacHeadingText() {
    return this.intl.t(`labels.parts.${this.args.model.signalChainHandler.dac.type.appName}`);
  }

  @action showChooseDacModal() {
    if (this.args.model.cdpDataHandler.parameterMappingData) {
      this.args.model.modalHandler.show(Constants.MODAL_TYPES.CHOOSE_DAC.value);
    } else {
      this.args.model.modalHandler.displayNotification(
        this.intl.t('messages.title', { htmlSafe: 'true' }),
        this.intl.t('messages.error-pst-data'),
      );
    }
  }
}
